// extracted by mini-css-extract-plugin
module.exports = {"center":"Comments_center__3ah0r"};